import {createAction} from 'redux-actions'

const action = name => createAction(`email-server/${name}`)

export const setIsLoading = action('SET_IS_LOADING')
export const setData = action('SET_DATA')
